"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethods = [
    'DEBIT',
    'CREDIT',
    'CASH',
    'DKV_CARD',
    'PAYPAL',
    'ONLINE',
];
class Receipt {
    static getDate(receipt) {
        if (!receipt.date) {
            return receipt.date;
        }
        return receipt.date.toDate
            ? receipt.date.toDate()
            : receipt.date;
    }
}
exports.default = Receipt;
//# sourceMappingURL=Receipt.js.map